import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  AppBar,
  Toolbar,
  DialogActions,
} from "@mui/material";
import { ErrorOutline, Close } from "@mui/icons-material";
import BackWithArrow from "../../common/BackWithArrow";
import FailedIconDesign from "../../common/FailedIconDesign";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function FailedCalibrationsButton() {
  const [open, setOpen] = useState(false);

  const dummyData = [
    {
      id: 1,
      equipment: "EQ1",
      failureDate: "2023-09-20",
      reason: "Sensor Error",
    },
    {
      id: 2,
      equipment: "EQ2",
      failureDate: "2023-09-18",
      reason: "Mechanical Issue",
    },
    {
      id: 3,
      equipment: "EQ3",
      failureDate: "2023-09-15",
      reason: "Calibration Drift",
    },
  ];

  return (
    <>
      <FailedIconDesign
        //variant="outlined"
        //color="error"
        startIcon={<ErrorOutline />}
        onClick={() => setOpen(true)}
      />

      <Dialog open={open} onClose={() => setOpen(false)} fullScreen>
        <BackWithArrow onBack={() => setOpen(false)} />

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>ID</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Equipment</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Failure Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Reason</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dummyData.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.equipment}</TableCell>
                      <TableCell>{item.failureDate}</TableCell>
                      <TableCell>{item.reason}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", p: 3 }}>
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#4F46E5",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#FFFFFF",
                color: "#4F46E5",
              },
            }}
            startIcon={<RestartAltIcon color="#4F46E5" />}
          >
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
